import { CommonModule }      from '@angular/common';
import { NgModule }          from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgModule }         from '@shared/components/svg/svg.module';
import { LinkItemComponent } from './link-item.component';


@NgModule( {
	declarations: [
		LinkItemComponent
	],
	imports: [
		// Angular
		CommonModule,

		// ThirdParty
		NgbCollapseModule,

		// Shared
		SvgModule
	],
	exports: [
		LinkItemComponent
	]
} )
export class LinkItemModule {}
